// extracted by mini-css-extract-plugin
export default {"container":"check-inventory-button__container___13Wn4"};